import Flatpickr from 'react-flatpickr';
import { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';

function TimePicker({ onDataChange, defaultDate }) {

  const initialDate = useRef(defaultDate || new Date());

  const options = useMemo(() => ({
    mode: 'single',
    static: true,
    monthSelectorType: 'static',
    enableTime: true,
    minDate: new Date(),
    time_24hr: true,
    dateFormat: 'M j, Y  H:i',
    defaultDate: [initialDate.current],
    prevArrow: '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
    nextArrow: '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>',
    onReady: (timeSelected, dateStr, instance) => {
      instance.element.value = dateStr.replace('to', '-');
    },
    onChange: (timeSelected, dateStr, instance) => {
      instance.element.value = dateStr.replace('to', '-');
      if (timeSelected.length > 0) {
        onDataChange(timeSelected);
      }
    },
  }), []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <Flatpickr
        className="form-input pl-9 text-gray-500 hover:text-gray-600 font-medium focus:border-gray-300 w-48"
        options={options}
      />
      <div className="absolute inset-0 right-auto flex items-center pointer-events-none z-30">
        <svg className="w-4 h-4 fill-current text-gray-500 ml-3" viewBox="0 0 16 16">
          <path d="M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-1 12H2V6h12v8z" />
        </svg>
      </div>
    </div>
  );
}

TimePicker.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  defaultDate: PropTypes.any,
};

export default TimePicker;
